import { classNames } from 'primereact/utils';
import SmallLoader from '../../../loaders/SmallLoader';

// Компонент - кнопка действия в шапке для контент-поля.
export function TableButton({ name, addClassName, onClick, isLoading }: any) {
    let tableButtonClassName = classNames(addClassName, {
        "table-button-div": true
    })
    return (
        <button className={tableButtonClassName} onClick={onClick}>
            {isLoading
                ?
                <SmallLoader iconColor="black" text="Загрузка..."/>
                :
                <span>{name}</span>
            }
        </button>
    );
}

